import type { FasceOrarie } from '../../../utility_objects/FasceOrarieUtils';
import type { FinestraOraria } from '../../../utility_objects/FinestraOraria';

/**
 * Ore di sempre del giornaliero Utente, che parte dalle 7: con Ore «Tutte»
 * nel riquadro Visualizzazione e nei giorni senza orari.
 */
export const FINESTRA_PREDEFINITA_UTENTE: Readonly<FinestraOraria> = {
  startHour: 7,
  endHour: 24,
};

/** Un utente in colonna, come lo dà useUsersHoursCalendar. */
export interface UtenteInColonna {
  userId: string;
}

/**
 * Orari del giornaliero Utente come li dà useUsersHoursCalendar, per il giorno
 * mostrato: le fasce per utente (senza data) e gli utenti in colonna, uno per
 * colonna; vuoto senza utenti.
 */
export type OrariUtentiServer = readonly [
  Readonly<Record<string, FasceOrarie | null | undefined>>?,
  ReadonlyArray<UtenteInColonna>?
];

/**
 * Utenti in colonna, nell'ordine delle colonne; undefined senza orari (in
 * caricamento) o senza l'elenco degli utenti, quando il calendario non è
 * raggruppato.
 */
export function getUtentiInColonna(
  calendario: OrariUtentiServer | null | undefined
): string[] | undefined {
  return calendario?.[1]?.map(({ userId }) => userId);
}

/**
 * Orari del giornaliero Utente per la finestra «Solo orario»: il giorno
 * mostrato → le fasce di tutti gli utenti in colonna. È l'unione delle bande che
 * il calendario disegna, una per colonna (la cella è in orario se cade in una
 * fascia del suo utente), perché l'asse delle ore è uno solo. Le fasce passano
 * tutte: quelle non valide le scarta chi le legge (FinestraOraria). undefined
 * senza orari (in caricamento), come la mappa dell'agenda negozio.
 */
export function getOrariUtenti(
  calendario: OrariUtentiServer | null | undefined,
  giorno: string
): Record<string, FasceOrarie[]> | undefined {
  if (!calendario) return undefined;
  const [orariUtenti] = calendario;
  const fasce: FasceOrarie[] = [];
  for (const userId of getUtentiInColonna(calendario) ?? []) {
    const delUtente = orariUtenti?.[userId];
    if (delUtente) fasce.push(delUtente);
  }
  return { [giorno]: fasce };
}
